import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const transactionTypeService = {
    getAlltransactionTypes,
    gettransactionType,
    updatetransactionType,
    createtransactionType,
    updatetransactionTypeStatus
};

const MODULE = {
    TYPE: 'transaction-types',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAlltransactionTypes(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.TYPE}`, requestOptions)
  }

  export function gettransactionType(id) {   
        
     return apiHelper(API_URL).get(`/${MODULE.TYPE}/${id}`)
  }

  export function updatetransactionType(data) {
    const requestOptions = {
      name: data.name,
    }


    return apiHelper(API_URL).put(`/${MODULE.TYPE}/${data.id}`, requestOptions)     
  }

  export function createtransactionType(data) {
    const requestOptions = {
      name: data.name,
    }
    
  
      return apiHelper(API_URL).post(`/${MODULE.TYPE}`, requestOptions)
  }

  export function updatetransactionTypeStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.TYPE}/${data.id}`, requestOptions)
    
  }